import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { Combo2Service } from "../../../services/index";
import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { SalesPlanService } from "../../../services/salesplan.service";

import { PrintData } from "../../master/print/print";
declare var google;

@Component({
  selector: "salesInvoice",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./plainpoEstimate.html",
})
export class plainpoEstimateComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    fin_year: "",
    party: "",
    design_no: "",
    fin_id: ""
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_id",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];
  invList = [];
  printData;

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("invoiceTemplate") invoiceTemplate: TemplateRef<any>;
  @ViewChild("detailsTemplate") detailsTemplate: TemplateRef<any>;
  @ViewChild("convertWTemplate") convertWTemplate: TemplateRef<any>;
  @ViewChild("verifyTemplate") verifyTemplate: TemplateRef<any>;
  @ViewChild("convertRTemplate") convertRTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("splTemplate") splTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("finAuto") finAuto;
  @ViewChild("partyAuto") partyAuto;

  finCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  invCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  print: boolean = false;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  invoiceList: any = [];
  totpcs: any;
  inv_no: "";
  dcid: "";

  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private modalService: BsModalService,
    public toasterService: ToasterService,
    private salesinvservice: SalesInvoiceService,
    private salesservice: SalesPlanService

  ) { }

  ngOnInit(): void {
    this.finyearCombo();
    this.getColumns();
  
    // this.getPartyList();
    // this.getInvoiceCombo();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Ref No",
        prop: "ref_id",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Ref Date",
        prop: "ref_date_formatted",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Season",
        prop: "season",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Party Name",
        prop: "party_name",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
      {
        name: "Design No",
        prop: "design_no",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Ord.Qty",
        prop: "ord_total",
        headerClass: "text-center",
        cellClass: "text-left",
        minWidth: 180,
        maxWidth: 180,
        width: 180,
      },
   
      {
        name: "Del.Pend Qty",
        prop: "ordpend_total",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Avl.Total",
        prop: "avl_total",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "PoNeed.Qty",
        prop: "need_tot",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      // {name: 'No of Designs',prop: 'no_of_design',headerClass:'text-center',cellClass: 'text-center', minWidth: 80,maxWidth: 80,width: 80 },
      // {
      //   name: "Details",
      //   prop: "sno",
      //   minWidth: 130,
      //   maxWidth: 130,
      //   cellClass: "text-center",
      //   width: 130,
      //   sortable: false,
      //   cellTemplate: this.editDeleteTemplate,
      // },
      {
        name: "Convert To PO",
        prop: "sno",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        cellClass: "text-center",
        sortable: false,
        cellTemplate: this.detailsTemplate,
      },
      // {
      //   name: "Invoice",
      //   prop: "sno",
      //   minWidth: 60,
      //   maxWidth: 60,
      //   width: 60,
      //   cellClass: "text-center",
      //   sortable: false,
      //   cellTemplate: this.invoiceTemplate,
      // },
      // {
      //   name: "Verify",
      //   prop: "sno",
      //   minWidth: 60,
      //   maxWidth: 60,
      //   width: 60,
      //   cellClass: "text-center",
      //   sortable: false,
      //   cellTemplate: this.verifyTemplate,
      // },
    ];
    // if(this.menu.sale_type == "estimate"){
    //     let obj = { name: 'Convert-Wholesale', prop: 'sno', minWidth: 80, maxWidth: 80, width: 80, cellClass: 'text-center',sortable: false, cellTemplate: this.convertWTemplate },
    //     obj1 = { name: 'Convert-Retail', prop: 'sno', minWidth: 80, maxWidth: 80, width: 80, cellClass: 'text-center',sortable: false, cellTemplate: this.convertRTemplate };
    //     this.columns.push(obj);
    //     this.columns.push(obj1);
    // }


    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
    a.removeClass("mat-autocomplete-visible");
    setTimeout(function () {
      $("#finyear").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 300);
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  bsModalRef: BsModalRef;
  viewInvoice(row) {
    let params = {
      printType: "counterDCdetails",
      party_id: row.party_id,
      dcid: row.dcid,
    };
    this.salesinvservice.salesInvoicePrint(params).then((res: any) => {
      // let var = "<div>aaaa</div>"
      this.printData = res;
      this.bsModalRef = this.modalService.show(PrintData, {
        keyboard: false,
        ignoreBackdropClick: true,
        class: "compWidth-70",
      });
      this.bsModalRef.content.stkdata = Object.assign({}, row);
      this.bsModalRef.content.printdet = this.printData;
    });
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getplainpoEstList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  verify(row) {
    this.inv_no = row.invoiceno;
    this.dcid = row.dcid;
  }

  clearFilter(): void {

    this.filter.design_no = "";
    this.applyFilter();
  }

  closeModal() {
    var verifiedby1 = document.getElementById("verifiedby") as HTMLInputElement;
    this.inv_no = "";
    this.dcid = "";
    verifiedby1.value = "";
  }
  saveModal() {
    var verifytemp = document.getElementById("verifiedby") as HTMLInputElement;
    var verifiedby = verifytemp.value;
    let params = {
      dcid: this.dcid,
      verifiedby: verifiedby,
    };
    let that = this;
    this.salesinvservice.saveEstimateVerify(params).then(function (res: any) {
      if (res.message == "Access Denied") {
        swal("ERROR", "<h2>INVOICE SCREEN ACCESS IS CLOSED !!</h2>", "error");
        return false
      }
      that.getplainpoEstList();
      this.dcid = "";
      this.inv_no = "";
    });

    this.dcid = "";
    this.inv_no = "";
    verifytemp.value = "";
  }

  applyFilter(): void {
    this.filterPanel.close();
    this.getplainpoEstList();
  }

  getplainpoEstList(): void {
    let params: any = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      design_no: this.filter.design_no,
      year: this.filter.fin_year,
      fin_id: this.filter.fin_id
    };

    params.type = "NOT VERIFIED";
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.salesservice
      .getplainpoEstList(params)
      .then(function (res: any) {

        if (res.message == "Access Denied") {
          swal("ERROR", "<h2>INVOICE SCREEN ACCESS IS CLOSED !!</h2>", "error");
          let tabObj = {
            action: "CloseTab",
            params: {},
          };
          setTimeout(() => {
            that.tabUpdateEvent.emit(tabObj);
          }, 2000);
        }

        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.invoiceList = res.data;
        // that.calcTotal();
      });
  }
  // calcTotal() {
  //   for (let i = 0; i < this.invoiceList.length; i++) {
  //     this.invoiceList[i].totpcs =
  //       parseInt(this.invoiceList[i].ftotpcs) +
  //       parseInt(this.invoiceList[i].htotpcs);
  //     this.invoiceList[i].inv_date_formatted = this.datePipe.transform(
  //       this.invoiceList[i].dcdt,
  //       "dd-MM-yyyy"
  //     );
  //   }
  // }


  // printDc(row) {

  //   let params = {
  //     start: 0,
  //     limit: 100,
  //     page: 1,
  //     inward_type: 'dc_print',
  //     dcid: row.dcid,
  //   };
  //   this.salesservice.getplainpoEstList(params).then((res: any) => {
  //     this.printData = res.data
  //     if (this.printData.length > 0) {
  //       let obj = {
  //         data: JSON.stringify(this.printData)
  //       }
  //       this.salesservice.counterDcprint(obj).then(function (res: any) { })
  //     }
  //   });
  // }


  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
        // that.finyearCtrl.setValue(res.data[0].fin_id);
            that.filter.fin_id = res.data[0].fin_id;
        that.filter.fin_year = res.data[0].finyear;
    });
  }

  displayFn(comboType: string, id: any) {
    let list: any = [];

    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      this.filter.fin_id = id
      let fitem = _.find(list, { fin_id: id });
      this.filter.fin_year = fitem["finyear"];
      return fitem["finyear"];
    }
    return "";
  }

  // getPartyList() {
  //   this.salesinvservice.getSalesParty({}).then((res: any) => {
  //     this.partyList = res;
  //   });
  // }

 
  convertTopo(row) {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getplainpoEstList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    tabObj = {
      action: "NewTab",
      params: {
        //  tabParent: 'Transaction',
        tabName: "ADD PURCHASE ORDER",
        title: "ADD PURCHASE ORDER",
        tabParent: "CLOTH",
        mode: 'Convert',
        data: row,
        name: "ADD PURCHASE ORDER",
      },
    };
    
    this.tabUpdateEvent.emit(tabObj);
  }



}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/poplan/plainpoEstimate.ts